/**
 * WordPress dependencies.
 */
import { __,_x } from '@wordpress/i18n';

import {InspectorControls} from '@wordpress/block-editor';

import {
    PanelBody,
    SelectControl,
	TextControl,
} from '@wordpress/components';

import {
    Fragment
} from '@wordpress/element';


const InsSettings = ({
    attributes,
    setAttributes
}) => {
       
    return (
        <Fragment>
        <InspectorControls>
                <Fragment>
                <PanelBody title={ __( 'Layout Setting', 'vayu-blocks' ) }
                    className="th-adv-wrapper-loop-setting-panel" initialOpen={ true }   
                >
                    <SelectControl
								label={ __( 'Pagination Type', 'vayu-blocks' ) }
								value={ attributes.paginationType}
								options={ [
									{ label:  __( 'Load More Button', 'vayu-blocks' ), value: 'loadmorebtn' },
									{ label: __( 'Infinite Loader', 'vayu-blocks' ), value: 'loadinfinite' },
									
								] }
								onChange={ e => setAttributes({ paginationType: e }) }
					/>
					<TextControl
								label={__('Laod More Text', 'vayu-blocks')}
								value={attributes.loadMoreBtnText}
								onChange={(value) => setAttributes({ loadMoreBtnText: value })}
					/>
					<TextControl
								label={__('Loading Text', 'vayu-blocks')}
								value={attributes.loadMoreText}
								onChange={(value) => setAttributes({ loadMoreText: value })}
					/>
					<TextControl
								label={__('No More Post Text', 'vayu-blocks')}
								value={attributes.noMorePostText}
								onChange={(value) => setAttributes({ noMorePostText: value })}
					/>
               
                </PanelBody>
                </Fragment>
                
                 </InspectorControls>
                </Fragment>
               
        )

}

export default InsSettings;